import type { BroadcastType } from "src/types/broadcasts";
import newsIcon from "../images/News.png";
import promosIcon from "../images/Promos.png";

export const BROADCAST_TYPE_ICONS: Record<BroadcastType, string> = {
  NEWS: newsIcon,
  PROMOTIONAL: promosIcon,
};

export const BROADCAST_TYPE_ICON_ALT: Record<BroadcastType, string> = {
  NEWS: "News",
  PROMOTIONAL: "Promotional",
};
